import { render } from "./TvmFullFillmentText.vue?vue&type=template&id=50d89ca1&scoped=true"
import script from "./TvmFullFillmentText.js?vue&type=script&lang=js&external"
export * from "./TvmFullFillmentText.js?vue&type=script&lang=js&external"

import "./TvmFullFillmentText.vue?vue&type=style&index=0&id=50d89ca1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50d89ca1"]])

export default __exports__